import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useMemo } from 'react';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';

type ScanResultItem = Record<string, any>;

interface ScanResultsProps {
  scanData: any;
  schema: any;
}

type ColumnType = {
  value: string;
  label: string;
} & Record<string, any>;

const ScanResults = ({ scanData, schema }: ScanResultsProps) => {
  const schemaKey = get(schema, 'rootKey', get(schema, 'key'));
  const schemaColumns = get(schema, 'columns', []);

   const rows = useMemo(() => {
    const scanResults = get(scanData, schemaKey, scanData);
    
    if (scanData && Array.isArray(scanData) && scanData.length > 0) {
      if (schemaColumns.length) {
        return scanData.map((item: Record<string, any>) => {
          return schemaColumns.reduce((acc: any, col: any) => {
            acc[col.value] = item[col.value];
            return acc;
          }, {} as Record<string, any>);
        });
      } else {
        return scanData.map((item: ScanResultItem) => {
          return {
            name: item.name,
            address: item.id,
          };
        });
      }
    }
    return [];
  }, [scanData, schemaKey, schemaColumns]);

  const columns: ColumnType[] = useMemo(() => {
    return schemaColumns && schemaColumns.length > 0
      ? schemaColumns
      : rows && rows.length > 0
      ? Object.keys(rows[0]).map((key) => ({ value: key, label: capitalize(key) }))
      : [];
  }, [rows, schemaColumns]);

  return (
    <Table>
      <TableHead>
        <TableRow>
          {columns.map((column) => (
            <TableCell key={column.value}>{column.label}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.length > 0 ? (
          rows.map((tag: any, rowIndex: number) => (
            <TableRow key={tag.id || tag.name || `row-${rowIndex}`}>
              {columns.map((column: ColumnType) => (
                <TableCell key={column.value}>
                  {typeof tag[column.value] === 'object' ? JSON.stringify(tag[column.value]) : tag[column.value]}
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : (
          <TableRow sx={{ height: '200px' }}>
            <TableCell colSpan={Math.max(columns.length, 1)} sx={{ textAlign: 'center' }}>
              No Scan Results Found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default ScanResults;
